import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.ResubmitRequestPopupContent', {
    title: 'Resubmit {workflowName}',
    submitButton: 'Resubmit',
    request: 'Request',
    note: 'Please provide a comment for Approvers to see why you are changing the {workflowName}.',
    description: 'Approvers will need to make their decision once again due to the changes in the {workflowName}.',
    comment: 'Comment',
    commentPlaceholder: 'Please provide a comment...',
});
